import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft overflow-hidden" }
const _hoisted_3 = { class: "md:flex" }
const _hoisted_4 = { class: "md:w-64 bg-primary-800 p-6 flex flex-col items-center" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "w-32 h-32 rounded-full bg-primary-600 flex items-center justify-center border-4 border-white shadow-lg"
}
const _hoisted_8 = { class: "text-4xl font-bold text-white" }
const _hoisted_9 = { class: "absolute bottom-0 right-0 w-10 h-10 bg-accent-600 hover:bg-accent-700 rounded-full flex items-center justify-center cursor-pointer transition-colors shadow-lg" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
  })
], -1)
const _hoisted_11 = { class: "mt-4 text-xl font-heading font-bold text-white" }
const _hoisted_12 = { class: "text-primary-200 text-sm" }
const _hoisted_13 = { class: "flex-1 p-6" }
const _hoisted_14 = { class: "flex items-center justify-between mb-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800" }, " Contact Information ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "grid gap-4 sm:grid-cols-2" }
const _hoisted_20 = { class: "space-y-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-primary-500" }, "Phone", -1)
const _hoisted_22 = { class: "text-primary-800 font-medium" }
const _hoisted_23 = { class: "space-y-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-primary-500" }, "Communication Preference", -1)
const _hoisted_25 = { class: "text-primary-800 font-medium capitalize" }
const _hoisted_26 = { class: "space-y-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-primary-500" }, "Directory Listing", -1)
const _hoisted_28 = { class: "text-primary-800 font-medium" }
const _hoisted_29 = {
  key: 0,
  class: "bg-amber-50 border border-amber-300 rounded-xl p-6"
}
const _hoisted_30 = { class: "flex items-start gap-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-amber-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    })
  ])
], -1)
const _hoisted_32 = { class: "flex-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-amber-800 mb-1" }, " Past Dues Outstanding ", -1)
const _hoisted_34 = { class: "text-amber-700 mb-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  })
], -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Pay Past Dues ")
const _hoisted_37 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6" }
const _hoisted_38 = { class: "flex items-center justify-between mb-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800" }, " Home Information ", -1)
const _hoisted_40 = { class: "grid gap-4 sm:grid-cols-2 mb-6" }
const _hoisted_41 = { class: "space-y-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-primary-500" }, "Address", -1)
const _hoisted_43 = { class: "text-primary-800 font-medium" }
const _hoisted_44 = { class: "space-y-1" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-primary-500" }, "Next HOA Payment Due", -1)
const _hoisted_46 = { class: "text-primary-800 font-medium" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  })
], -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Make Payment ")
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800 mb-6" }, " Payment History ", -1)
const _hoisted_52 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-12 h-12 mx-auto text-primary-300 mb-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
  })
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, "No recorded payments", -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_57 = { class: "min-w-full" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-primary-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-primary-500 uppercase tracking-wider" }, " Description "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-primary-500 uppercase tracking-wider" }, " Date "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-primary-500 uppercase tracking-wider" }, " Amount "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-primary-500 uppercase tracking-wider" }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3" })
  ])
], -1)
const _hoisted_59 = { class: "divide-y divide-primary-100" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "px-4 py-4 text-sm text-primary-800 font-medium" }, " HOA Dues Payment ", -1)
const _hoisted_61 = { class: "px-4 py-4 text-sm text-primary-600" }
const _hoisted_62 = { class: "px-4 py-4 text-sm text-primary-800 font-medium" }
const _hoisted_63 = { class: "px-4 py-4" }
const _hoisted_64 = { class: "px-4 py-4 text-right" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "bg-white rounded-xl shadow-xl w-full max-w-lg overflow-hidden" }
const _hoisted_67 = { class: "flex items-center justify-between px-6 py-4 border-b border-primary-200" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800" }, " Edit Your Settings ", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "px-6 py-4 space-y-4" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary-500" }, " Update your contact preferences. To change your email, please contact andy@foxwoodcrossing.com ", -1)
const _hoisted_73 = { class: "space-y-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-primary-700"
}, " Phone Number ", -1)
const _hoisted_75 = { class: "space-y-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", {
  for: "communication",
  class: "block text-sm font-medium text-primary-700"
}, " Communication Preferences ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("option", { value: "everything" }, "Everything", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("option", { value: "weekly" }, "Weekly Update", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", { value: "events" }, "Event Updates Only", -1)
const _hoisted_80 = [
  _hoisted_77,
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = { class: "flex items-center gap-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", {
  for: "directory",
  class: "text-sm text-primary-700"
}, " Show my phone number in the neighbor directory ", -1)
const _hoisted_83 = { class: "flex items-center gap-3" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", {
  for: "onboarding",
  class: "text-sm text-primary-700"
}, " Show getting started checklist on dashboard ", -1)
const _hoisted_85 = { class: "flex items-center justify-end gap-3 px-6 py-4 bg-primary-50 border-t border-primary-200" }
const _hoisted_86 = ["disabled"]

import router from "@/router";
import { HoodApi } from "@/services/HoodApi";
import { StripeService } from "@/services/StripeService";
import { useAuthStore } from "@/stores/auth";
import { computed, ref, watch, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
auth.fetch_user_data();

// Dues settings
const duesDueDate = ref("Loading...");

const fetchDuesSettings = async () => {
  try {
    const settings = await HoodApi.fetch_dues_settings();
    duesDueDate.value = settings.due_date_formatted;
  } catch (err) {
    console.error("Failed to fetch dues settings:", err);
    duesDueDate.value = "September 1, 2026"; // Fallback
  }
};

onMounted(() => {
  fetchDuesSettings();
});

const details = computed(() => auth.user_details);
const payments = computed(() => auth.payments);
const username = computed(() => auth.first_name + " " + auth.last_name);
const profile = computed(() => auth.profile);
const communication = computed(() => auth.communication);

// Past dues
const hasPastDues = computed(() => auth.hasPastDues);
const pastDuesCount = computed(() => auth.pastDuesCount);
const pastDuesTotalCents = computed(() => auth.pastDuesTotalCents);

const initials = computed(() => {
  const first = auth.first_name?.[0] || "";
  const last = auth.last_name?.[0] || "";
  return (first + last).toUpperCase();
});

const statusBadgeClass = computed(() => {
  const status = details.value?.house?.status;
  if (status === "good") return "bg-green-100 text-green-700";
  if (status === "delinquent") return "bg-red-100 text-red-700";
  return "bg-yellow-100 text-yellow-700";
});

const statusLabel = computed(() => {
  const status = details.value?.house?.status;
  if (status === "good") return "Good Standing";
  if (status === "delinquent") return "Payment Due";
  if (status === "for_sale") return "For Sale";
  return "Unclaimed";
});

const paymentStatusClass = (status: string) => {
  if (status === "succeeded") return "bg-green-100 text-green-700";
  if (status === "failed") return "bg-red-100 text-red-700";
  return "bg-yellow-100 text-yellow-700";
};

// Modal state
const showEditModal = ref(false);
const saving = ref(false);

// Edit form state - initialize when modal opens
const editPhone = ref("");
const editCommunication = ref("");
const editDirectoryEnabled = ref(false);
const editShowOnboarding = ref(false);

watch(showEditModal, (isOpen) => {
  if (isOpen) {
    editPhone.value = auth.phone || "";
    editCommunication.value = auth.communication || "everything";
    editDirectoryEnabled.value = auth.directory_enabled || false;
    // Inverted: checkbox is "show onboarding", state is "onboarding_dismissed"
    editShowOnboarding.value = !auth.onboarding_dismissed;
  }
});

const photo = ref();

const makePayment = () => {
  router.push("/payments");
};

const saveSettings = async () => {
  saving.value = true;
  try {
    await HoodApi.update_user_details({
      phone: editPhone.value,
      communication: editCommunication.value,
      directory_enabled: editDirectoryEnabled.value,
      onboarding_dismissed: !editShowOnboarding.value,
    });
    // Update local state
    auth.phone = editPhone.value;
    auth.communication = editCommunication.value;
    auth.directory_enabled = editDirectoryEnabled.value;
    auth.onboarding_dismissed = !editShowOnboarding.value;
    showEditModal.value = false;
  } catch (error) {
    console.error("Failed to update settings:", error);
  } finally {
    saving.value = false;
  }
};

const check_status = async (stripe_secret: string, id: number) => {
  const response = await StripeService.get_payment_status(stripe_secret);
  if (response.status === "succeeded") {
    await HoodApi.update_payment_status(response.status, id);
    auth.fetch_user_data();
  }
};

const handleProfilePic = async () => {
  if (!photo.value?.files?.length) return;
  const formData = new FormData();
  formData.append("file", photo.value.files[0]);
  await HoodApi.change_profile_pic(formData);
  await auth.fetch_user_data();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(profile))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg",
                  src: _unref(details).profile,
                  alt: "Profile photo"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(initials)), 1)
                ])),
            _createElementVNode("label", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("input", {
                type: "file",
                onChange: handleProfilePic,
                ref_key: "photo",
                ref: photo,
                class: "hidden",
                accept: "image/*"
              }, null, 544)
            ])
          ]),
          _createElementVNode("h2", _hoisted_11, _toDisplayString(_unref(username)), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(details).email), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showEditModal.value = true)),
              class: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-accent-600 hover:text-accent-700 hover:bg-accent-50 rounded-lg transition-colors"
            }, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(details).phone || "Not set"), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(communication) || "Not set"), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(details).directory_enabled
                    ? "Visible to neighbors"
                    : "Hidden from directory"), 1)
            ])
          ])
        ])
      ])
    ]),
    (_unref(hasPastDues))
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("p", _hoisted_34, [
                _createTextVNode(" You have " + _toDisplayString(_unref(pastDuesCount)) + " outstanding dues payment" + _toDisplayString(_unref(pastDuesCount) > 1 ? "s" : "") + " totaling ", 1),
                _createElementVNode("strong", null, "$" + _toDisplayString((_unref(pastDuesTotalCents) / 100).toFixed(2)), 1)
              ]),
              _createVNode(_component_router_link, {
                to: "/payments",
                class: "inline-flex items-center gap-2 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-lg transition-colors"
              }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _hoisted_36
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("span", {
          class: _normalizeClass(["px-3 py-1 text-sm font-medium rounded-full", _unref(statusBadgeClass)])
        }, _toDisplayString(_unref(statusLabel)), 3)
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("p", _hoisted_43, _toDisplayString(_unref(details).house?.house_number) + " " + _toDisplayString(_unref(details).house?.street), 1)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("p", _hoisted_46, _toDisplayString(duesDueDate.value), 1)
        ])
      ]),
      _createElementVNode("button", {
        onClick: makePayment,
        class: "inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors shadow-soft"
      }, _hoisted_49)
    ]),
    _createElementVNode("div", _hoisted_50, [
      _hoisted_51,
      (_unref(payments).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_55))
        : (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("table", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("tbody", _hoisted_59, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payments), (payment) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: payment.id,
                    class: "hover:bg-primary-50 transition-colors"
                  }, [
                    _hoisted_60,
                    _createElementVNode("td", _hoisted_61, _toDisplayString(payment.created_on), 1),
                    _createElementVNode("td", _hoisted_62, " $" + _toDisplayString((payment.amount / 100).toFixed(2)), 1),
                    _createElementVNode("td", _hoisted_63, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2 py-1 text-xs font-medium rounded-full", paymentStatusClass(payment.status)])
                      }, _toDisplayString(payment.status), 3)
                    ]),
                    _createElementVNode("td", _hoisted_64, [
                      (payment.status !== 'succeeded')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (check_status(payment.stripe_secret, payment.id)),
                            class: "text-sm text-accent-600 hover:text-accent-700 font-medium"
                          }, " Check Status ", 8, _hoisted_65))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
    ]),
    (showEditModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (showEditModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showEditModal.value = false)),
                class: "text-primary-400 hover:text-primary-600 transition-colors"
              }, _hoisted_70)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  id: "phone",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editPhone).value = $event)),
                  class: "w-full px-4 py-2 border border-primary-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
                  placeholder: "(414) XXX-XXXX"
                }, null, 512), [
                  [_vModelText, editPhone.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                _withDirectives(_createElementVNode("select", {
                  id: "communication",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editCommunication).value = $event)),
                  class: "w-full px-4 py-2 border border-primary-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors"
                }, _hoisted_80, 512), [
                  [_vModelSelect, editCommunication.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "directory",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editDirectoryEnabled).value = $event)),
                  class: "w-4 h-4 text-accent-600 border-primary-300 rounded focus:ring-accent-500"
                }, null, 512), [
                  [_vModelCheckbox, editDirectoryEnabled.value]
                ]),
                _hoisted_82
              ]),
              _createElementVNode("div", _hoisted_83, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "onboarding",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editShowOnboarding).value = $event)),
                  class: "w-4 h-4 text-accent-600 border-primary-300 rounded focus:ring-accent-500"
                }, null, 512), [
                  [_vModelCheckbox, editShowOnboarding.value]
                ]),
                _hoisted_84
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showEditModal.value = false)),
                class: "px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-800 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: saveSettings,
                disabled: saving.value,
                class: "px-6 py-2 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 disabled:opacity-50 transition-colors"
              }, _toDisplayString(saving.value ? "Saving..." : "Save Changes"), 9, _hoisted_86)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})